// Irregular English verbs only — three tenses with Russian translations.
// Compact row: [base, ruPresent, pastSimple, ruPast, ruFuture].
// Future English is always `will ${base}`. Prefixed compounds (undergo, rewrite…)
// are included because they inherit the same irregular past.
const RAW = [
  ['arise', 'возникаю', 'arose', 'возник', 'возникну'],
  ['awake', 'просыпаюсь', 'awoke', 'проснулся', 'проснусь'],
  ['be', 'являюсь', 'was', 'был', 'буду'],
  ['bear', 'несу', 'bore', 'нёс', 'понесу'],
  ['beat', 'бью', 'beat', 'бил', 'побью'],
  ['become', 'становлюсь', 'became', 'стал', 'стану'],
  ['befall', 'постигаю', 'befell', 'постиг', 'постигну'],
  ['beget', 'порождаю', 'begot', 'породил', 'порожу'],
  ['begin', 'начинаю', 'began', 'начал', 'начну'],
  ['behold', 'созерцаю', 'beheld', 'созерцал', 'буду созерцать'],
  ['bend', 'сгибаю', 'bent', 'согнул', 'согну'],
  ['bereave', 'лишаю', 'bereft', 'лишил', 'лишу'],
  ['beseech', 'умоляю', 'besought', 'умолял', 'буду умолять'],
  ['beset', 'осаждаю', 'beset', 'осаждал', 'осажу'],
  ['bespeak', 'заказываю', 'bespoke', 'заказал', 'закажу'],
  ['bestride', 'оседлываю', 'bestrode', 'оседлал', 'оседлаю'],
  ['bet', 'ставлю', 'bet', 'поставил', 'поставлю'],
  ['bid', 'предлагаю цену', 'bade', 'предложил цену', 'предложу цену'],
  ['bind', 'связываю', 'bound', 'связал', 'свяжу'],
  ['bite', 'кусаю', 'bit', 'укусил', 'укушу'],
  ['bleed', 'кровоточу', 'bled', 'кровоточил', 'буду кровоточить'],
  ['blow', 'дую', 'blew', 'дул', 'подую'],
  ['break', 'ломаю', 'broke', 'сломал', 'сломаю'],
  ['breed', 'развожу', 'bred', 'разводил', 'разведу'],
  ['bring', 'приношу', 'brought', 'принёс', 'принесу'],
  ['broadcast', 'транслирую', 'broadcast', 'транслировал', 'буду транслировать'],
  ['build', 'строю', 'built', 'строил', 'построю'],
  ['burn', 'жгу', 'burnt', 'жёг', 'сожгу'],
  ['burst', 'лопаюсь', 'burst', 'лопнул', 'лопну'],
  ['bust', 'ломаюсь', 'bust', 'сломался', 'сломаюсь'],
  ['buy', 'покупаю', 'bought', 'купил', 'куплю'],
  ['cast', 'бросаю', 'cast', 'бросил', 'брошу'],
  ['catch', 'ловлю', 'caught', 'поймал', 'поймаю'],
  ['chide', 'браню', 'chid', 'бранил', 'побраню'],
  ['choose', 'выбираю', 'chose', 'выбрал', 'выберу'],
  ['cleave', 'раскалываю', 'clove', 'расколол', 'расколю'],
  ['cling', 'цепляюсь', 'clung', 'цеплялся', 'зацеплюсь'],
  ['come', 'прихожу', 'came', 'пришёл', 'приду'],
  ['cost', 'стою', 'cost', 'стоил', 'буду стоить'],
  ['creep', 'крадусь', 'crept', 'крался', 'подкрадусь'],
  ['cut', 'режу', 'cut', 'резал', 'порежу'],
  ['deal', 'раздаю', 'dealt', 'раздал', 'раздам'],
  ['dig', 'копаю', 'dug', 'копал', 'выкопаю'],
  ['dive', 'ныряю', 'dove', 'нырнул', 'нырну'],
  ['do', 'делаю', 'did', 'делал', 'сделаю'],
  ['draw', 'рисую', 'drew', 'рисовал', 'нарисую'],
  ['dream', 'мечтаю', 'dreamt', 'мечтал', 'помечтаю'],
  ['drink', 'пью', 'drank', 'пил', 'выпью'],
  ['drive', 'вожу', 'drove', 'водил', 'буду водить'],
  ['dwell', 'обитаю', 'dwelt', 'обитал', 'буду обитать'],
  ['eat', 'ем', 'ate', 'ел', 'съем'],
  ['fall', 'падаю', 'fell', 'упал', 'упаду'],
  ['feed', 'кормлю', 'fed', 'кормил', 'покормлю'],
  ['feel', 'чувствую', 'felt', 'чувствовал', 'почувствую'],
  ['fight', 'сражаюсь', 'fought', 'сражался', 'буду сражаться'],
  ['find', 'нахожу', 'found', 'нашёл', 'найду'],
  ['fit', 'подхожу', 'fit', 'подошёл', 'подойду'],
  ['flee', 'бегу', 'fled', 'бежал', 'убегу'],
  ['fling', 'швыряю', 'flung', 'швырнул', 'швырну'],
  ['fly', 'летаю', 'flew', 'летел', 'полечу'],
  ['forbear', 'воздерживаюсь', 'forbore', 'воздержался', 'воздержусь'],
  ['forbid', 'запрещаю', 'forbade', 'запретил', 'запрещу'],
  ['forecast', 'прогнозирую', 'forecast', 'прогнозировал', 'спрогнозирую'],
  ['forego', 'отказываюсь', 'forwent', 'отказался', 'откажусь'],
  ['foresee', 'предвижу', 'foresaw', 'предвидел', 'предвижу'],
  ['foretell', 'предсказываю', 'foretold', 'предсказал', 'предскажу'],
  ['forget', 'забываю', 'forgot', 'забыл', 'забуду'],
  ['forgive', 'прощаю', 'forgave', 'простил', 'прощу'],
  ['forsake', 'покидаю', 'forsook', 'покинул', 'покину'],
  ['freeze', 'замерзаю', 'froze', 'замёрз', 'замёрзну'],
  ['gainsay', 'оспариваю', 'gainsaid', 'оспорил', 'оспорю'],
  ['get', 'получаю', 'got', 'получил', 'получу'],
  ['give', 'даю', 'gave', 'дал', 'дам'],
  ['go', 'иду', 'went', 'шёл', 'пойду'],
  ['grind', 'мелю', 'ground', 'молол', 'смелю'],
  ['grow', 'расту', 'grew', 'рос', 'вырасту'],
  ['hang', 'вешаю', 'hung', 'повесил', 'повешу'],
  ['have', 'имею', 'had', 'имел', 'буду иметь'],
  ['hear', 'слышу', 'heard', 'слышал', 'услышу'],
  ['heave', 'поднимаю', 'hove', 'поднял', 'подниму'],
  ['hide', 'прячу', 'hid', 'спрятал', 'спрячу'],
  ['hit', 'ударяю', 'hit', 'ударил', 'ударю'],
  ['hold', 'держу', 'held', 'держал', 'буду держать'],
  ['hurt', 'раню', 'hurt', 'ранил', 'пораню'],
  ['inlay', 'инкрустирую', 'inlaid', 'инкрустировал', 'инкрустирую'],
  ['input', 'ввожу', 'input', 'ввёл', 'введу'],
  ['inset', 'вставляю', 'inset', 'вставил', 'вставлю'],
  ['interweave', 'переплетаю', 'interwove', 'переплёл', 'переплету'],
  ['keep', 'храню', 'kept', 'хранил', 'сохраню'],
  ['kneel', 'становлюсь на колени', 'knelt', 'встал на колени', 'встану на колени'],
  ['knit', 'вяжу', 'knit', 'вязал', 'свяжу'],
  ['know', 'знаю', 'knew', 'знал', 'буду знать'],
  ['lay', 'кладу', 'laid', 'положил', 'положу'],
  ['lead', 'веду', 'led', 'вёл', 'поведу'],
  ['lean', 'опираюсь', 'leant', 'оперся', 'опрусь'],
  ['leap', 'прыгаю', 'leapt', 'прыгнул', 'прыгну'],
  ['learn', 'учусь', 'learnt', 'учился', 'научусь'],
  ['leave', 'ухожу', 'left', 'ушёл', 'уйду'],
  ['lend', 'одалживаю', 'lent', 'одолжил', 'одолжу'],
  ['let', 'позволяю', 'let', 'позволил', 'позволю'],
  ['lie', 'лежу', 'lay', 'лежал', 'полежу'],
  ['light', 'зажигаю', 'lit', 'зажёг', 'зажгу'],
  ['lose', 'теряю', 'lost', 'потерял', 'потеряю'],
  ['make', 'создаю', 'made', 'создал', 'создам'],
  ['mean', 'значу', 'meant', 'значил', 'буду значить'],
  ['meet', 'встречаю', 'met', 'встретил', 'встречу'],
  ['miscast', 'неверно распределяю роли', 'miscast', 'неверно распределил роли', 'неверно распределю роли'],
  ['misdeal', 'ошибчиво раздаю', 'misdealt', 'ошибчиво раздал', 'ошибчиво раздам'],
  ['misdo', 'поступаю неверно', 'misdid', 'поступил неверно', 'поступлю неверно'],
  ['mishear', 'ослышиваюсь', 'misheard', 'ослышался', 'ослышусь'],
  ['mislay', 'закладываю не туда', 'mislaid', 'заложил не туда', 'заложу не туда'],
  ['mislead', 'ввожу в заблуждение', 'misled', 'ввёл в заблуждение', 'введу в заблуждение'],
  ['misread', 'неверно читаю', 'misread', 'неверно прочитал', 'неверно прочитаю'],
  ['misspell', 'пишу с ошибкой', 'misspelt', 'написал с ошибкой', 'напишу с ошибкой'],
  ['misspend', 'трачу зря', 'misspent', 'потратил зря', 'потрачу зря'],
  ['mistake', 'ошибаюсь', 'mistook', 'ошибся', 'ошибусь'],
  ['misunderstand', 'неправильно понимаю', 'misunderstood', 'неправильно понял', 'неправильно пойму'],
  ['offset', 'компенсирую', 'offset', 'компенсировал', 'компенсирую'],
  ['outbid', 'перебиваю цену', 'outbid', 'перебил цену', 'перебью цену'],
  ['outdo', 'превосхожу', 'outdid', 'превзошёл', 'превзойду'],
  ['outgrow', 'перерастаю', 'outgrew', 'перерос', 'перерасту'],
  ['outrun', 'обгоняю', 'outran', 'обогнал', 'обгоню'],
  ['outsell', 'продаю больше', 'outsold', 'продавал больше', 'буду продавать больше'],
  ['outshine', 'затмеваю', 'outshone', 'затмил', 'затмлю'],
  ['overcast', 'затягиваю тучами', 'overcast', 'затянул тучами', 'затяну тучами'],
  ['overcome', 'преодолеваю', 'overcame', 'преодолел', 'преодолею'],
  ['overdo', 'перебарщиваю', 'overdid', 'переборщил', 'переборщу'],
  ['overdraw', 'превышаю счёт', 'overdrew', 'превысил счёт', 'превышу счёт'],
  ['overeat', 'переедаю', 'overate', 'переел', 'переем'],
  ['overhang', 'нависаю', 'overhung', 'нависал', 'буду нависать'],
  ['overhear', 'подслушиваю', 'overheard', 'подслушал', 'подслушаю'],
  ['overlay', 'накладываю', 'overlaid', 'наложил', 'наложу'],
  ['overlie', 'лежу сверху', 'overlay', 'лежал сверху', 'буду лежать сверху'],
  ['override', 'переопределяю', 'overrode', 'переопределил', 'переопределю'],
  ['overrun', 'захватываю', 'overran', 'захватил', 'захвачу'],
  ['oversee', 'надзираю', 'oversaw', 'надзирал', 'буду надзирать'],
  ['oversell', 'перепродаю', 'oversold', 'перепродал', 'перепродам'],
  ['overshoot', 'промахиваюсь', 'overshot', 'промахнулся', 'промахнусь'],
  ['oversleep', 'просыпаю', 'overslept', 'проспал', 'просплю'],
  ['overtake', 'обгоняю', 'overtook', 'обогнал', 'обгоню'],
  ['overthrow', 'свергаю', 'overthrew', 'сверг', 'свергну'],
  ['overwrite', 'перезаписываю', 'overwrote', 'перезаписал', 'перезапишу'],
  ['partake', 'принимаю участие', 'partook', 'принял участие', 'приму участие'],
  ['pay', 'оплачиваю', 'paid', 'оплатил', 'оплачу'],
  ['plead', 'умоляю', 'pled', 'умолял', 'буду умолять'],
  ['proofread', 'вычитываю', 'proofread', 'вычитал', 'вычитаю'],
  ['put', 'кладу', 'put', 'положил', 'положу'],
  ['quit', 'бросаю', 'quit', 'бросил', 'брошу'],
  ['read', 'читаю', 'read', 'читал', 'прочитаю'],
  ['rebind', 'переплетаю заново', 'rebound', 'переплёл заново', 'переплету заново'],
  ['rebuild', 'перестраиваю', 'rebuilt', 'перестроил', 'перестрою'],
  ['recast', 'переделываю', 'recast', 'переделал', 'переделаю'],
  ['redo', 'переделываю заново', 'redid', 'переделал заново', 'переделаю заново'],
  ['redraw', 'перерисовываю', 'redrew', 'перерисовал', 'перерисую'],
  ['rehear', 'переслушиваю', 'reheard', 'переслушал', 'переслушаю'],
  ['relight', 'зажигаю снова', 'relit', 'зажёг снова', 'зажгу снова'],
  ['remake', 'переснимаю', 'remade', 'переснял', 'пересниму'],
  ['rend', 'разрываю', 'rent', 'разорвал', 'разорву'],
  ['repay', 'возвращаю долг', 'repaid', 'вернул долг', 'верну долг'],
  ['reread', 'перечитываю', 'reread', 'перечитал', 'перечитаю'],
  ['rerun', 'перезапускаю', 'reran', 'перезапустил', 'перезапущу'],
  ['resell', 'перепродаю', 'resold', 'перепродал', 'перепродам'],
  ['reset', 'сбрасываю', 'reset', 'сбросил', 'сброшу'],
  ['retake', 'пересдаю', 'retook', 'пересдал', 'пересдам'],
  ['retell', 'пересказываю', 'retold', 'пересказал', 'перескажу'],
  ['rethink', 'переосмысляю', 'rethought', 'переосмыслил', 'переосмыслю'],
  ['rewind', 'перематываю', 'rewound', 'перемотал', 'перемотаю'],
  ['rewrite', 'переписываю', 'rewrote', 'переписал', 'перепишу'],
  ['rid', 'избавляю', 'rid', 'избавил', 'избавлю'],
  ['ride', 'катаюсь', 'rode', 'катался', 'покатаюсь'],
  ['ring', 'звоню', 'rang', 'звонил', 'позвоню'],
  ['rise', 'поднимаюсь', 'rose', 'поднялся', 'поднимусь'],
  ['run', 'бегу', 'ran', 'бежал', 'побегу'],
  ['say', 'говорю', 'said', 'сказал', 'скажу'],
  ['see', 'вижу', 'saw', 'видел', 'увижу'],
  ['seek', 'ищу', 'sought', 'искал', 'поищу'],
  ['sell', 'продаю', 'sold', 'продал', 'продам'],
  ['send', 'отправляю', 'sent', 'отправил', 'отправлю'],
  ['set', 'устанавливаю', 'set', 'установил', 'установлю'],
  ['shake', 'трясу', 'shook', 'тряс', 'потрясу'],
  ['shear', 'стригу', 'shore', 'стриг', 'остригу'],
  ['shed', 'сбрасываю', 'shed', 'сбросил', 'сброшу'],
  ['shine', 'сияю', 'shone', 'сиял', 'буду сиять'],
  ['shoot', 'стреляю', 'shot', 'стрелял', 'выстрелю'],
  ['shrink', 'сжимаюсь', 'shrank', 'сжался', 'сожмусь'],
  ['shut', 'захлопываю', 'shut', 'захлопнул', 'захлопну'],
  ['sing', 'пою', 'sang', 'пел', 'спою'],
  ['sink', 'тону', 'sank', 'тонул', 'утону'],
  ['sit', 'сижу', 'sat', 'сидел', 'посижу'],
  ['slay', 'убиваю', 'slew', 'убил', 'убью'],
  ['sleep', 'сплю', 'slept', 'спал', 'посплю'],
  ['slide', 'скольжу', 'slid', 'скользил', 'буду скользить'],
  ['sling', 'швыряю', 'slung', 'швырнул', 'швырну'],
  ['slink', 'крадусь', 'slunk', 'крался', 'подкрадусь'],
  ['slit', 'разрезаю', 'slit', 'разрезал', 'разрежу'],
  ['smell', 'нюхаю', 'smelt', 'нюхал', 'понюхаю'],
  ['smite', 'поражаю', 'smote', 'поразил', 'поражу'],
  ['sneak', 'подкрадываюсь', 'snuck', 'подкрался', 'подкрадусь'],
  ['speak', 'разговариваю', 'spoke', 'разговаривал', 'поговорю'],
  ['speed', 'мчусь', 'sped', 'мчался', 'помчусь'],
  ['spell', 'произношу по буквам', 'spelt', 'произнёс по буквам', 'произнесу по буквам'],
  ['spend', 'трачу', 'spent', 'потратил', 'потрачу'],
  ['spill', 'проливаю', 'spilt', 'пролил', 'пролью'],
  ['spin', 'кручусь', 'spun', 'крутился', 'покручусь'],
  ['spit', 'плюю', 'spat', 'плюнул', 'плюну'],
  ['split', 'раскалываю', 'split', 'расколол', 'расколю'],
  ['spoil', 'порчу', 'spoilt', 'испортил', 'испорчу'],
  ['spread', 'распространяю', 'spread', 'распространил', 'распространю'],
  ['spring', 'вскакиваю', 'sprang', 'вскочил', 'вскочу'],
  ['stand', 'стою', 'stood', 'стоял', 'постою'],
  ['steal', 'краду', 'stole', 'украл', 'украду'],
  ['stick', 'приклеиваю', 'stuck', 'приклеил', 'приклею'],
  ['sting', 'жалю', 'stung', 'ужалил', 'ужалю'],
  ['stink', 'воняю', 'stank', 'вонял', 'буду вонять'],
  ['stride', 'шагаю', 'strode', 'шагал', 'пошагаю'],
  ['strike', 'ударяю', 'struck', 'ударил', 'ударю'],
  ['string', 'нанизываю', 'strung', 'нанизал', 'нанижу'],
  ['strive', 'стремлюсь', 'strove', 'стремился', 'буду стремиться'],
  ['swear', 'клянусь', 'swore', 'поклялся', 'поклянусь'],
  ['sweep', 'подметаю', 'swept', 'подметал', 'подмету'],
  ['swim', 'плаваю', 'swam', 'плавал', 'поплаваю'],
  ['swing', 'качаюсь', 'swung', 'качался', 'покачаюсь'],
  ['take', 'беру', 'took', 'взял', 'возьму'],
  ['teach', 'обучаю', 'taught', 'обучал', 'обучу'],
  ['tear', 'рву', 'tore', 'порвал', 'порву'],
  ['tell', 'рассказываю', 'told', 'рассказал', 'расскажу'],
  ['think', 'думаю', 'thought', 'думал', 'подумаю'],
  ['thrive', 'процветаю', 'throve', 'процветал', 'буду процветать'],
  ['throw', 'бросаю', 'threw', 'бросил', 'брошу'],
  ['thrust', 'вонзаю', 'thrust', 'вонзил', 'вонжу'],
  ['tread', 'ступаю', 'trod', 'ступал', 'ступлю'],
  ['unbend', 'разгибаю', 'unbent', 'разогнул', 'разогну'],
  ['unbind', 'развязываю', 'unbound', 'развязал', 'развяжу'],
  ['underbid', 'занижаю цену', 'underbid', 'занизил цену', 'занижу цену'],
  ['undercut', 'сбиваю цену', 'undercut', 'сбил цену', 'собью цену'],
  ['undergo', 'претерпеваю', 'underwent', 'претерпел', 'претерплю'],
  ['underlie', 'лежу в основе', 'underlay', 'лежал в основе', 'буду лежать в основе'],
  ['underpay', 'недоплачиваю', 'underpaid', 'недоплатил', 'недоплачу'],
  ['undersell', 'продаю дешевле', 'undersold', 'продавал дешевле', 'буду продавать дешевле'],
  ['understand', 'понимаю', 'understood', 'понял', 'пойму'],
  ['undertake', 'предпринимаю', 'undertook', 'предпринял', 'предприму'],
  ['underwrite', 'страхую', 'underwrote', 'застраховал', 'застрахую'],
  ['undo', 'отменяю', 'undid', 'отменил', 'отменю'],
  ['unfreeze', 'размораживаю', 'unfroze', 'разморозил', 'разморожу'],
  ['unhang', 'снимаю с крюка', 'unhung', 'снял с крюка', 'сниму с крюка'],
  ['unhide', 'показываю спрятанное', 'unhid', 'показал спрятанное', 'покажу спрятанное'],
  ['unlearn', 'отучаюсь', 'unlearnt', 'отучился', 'отучусь'],
  ['unmake', 'разрушаю созданное', 'unmade', 'разрушил созданное', 'разрушу созданное'],
  ['unwind', 'разматываю', 'unwound', 'размотал', 'размотаю'],
  ['uphold', 'поддерживаю', 'upheld', 'поддержал', 'поддержу'],
  ['upset', 'расстраиваю', 'upset', 'расстроил', 'расстрою'],
  ['wake', 'бужу', 'woke', 'разбудил', 'разбужу'],
  ['waylay', 'подстерегаю', 'waylaid', 'подстерёг', 'подстерегу'],
  ['wear', 'ношу', 'wore', 'носил', 'буду носить'],
  ['weave', 'тку', 'wove', 'ткал', 'сотку'],
  ['wed', 'венчаюсь', 'wed', 'венчался', 'повенчаюсь'],
  ['weep', 'плачу', 'wept', 'плакал', 'поплачу'],
  ['wet', 'смачиваю', 'wet', 'смочил', 'смочу'],
  ['win', 'выигрываю', 'won', 'выиграл', 'выиграю'],
  ['wind', 'наматываю', 'wound', 'намотал', 'намотаю'],
  ['withdraw', 'отзываю', 'withdrew', 'отозвал', 'отзову'],
  ['withhold', 'удерживаю', 'withheld', 'удержал', 'удержу'],
  ['withstand', 'выдерживаю', 'withstood', 'выдержал', 'выдержу'],
  ['wring', 'выжимаю', 'wrung', 'выжал', 'выжму'],
  ['write', 'пишу', 'wrote', 'писал', 'напишу'],
];

// 1 — A1 everyday irregulars, 5 — rare / literary / prefixed.
// Levels slide along this scale so difficulty rises gradually.
const TIER_LISTS = [
  [
    'be', 'become', 'begin', 'break', 'bring', 'build', 'buy', 'catch', 'choose',
    'come', 'cut', 'do', 'draw', 'drink', 'drive', 'eat', 'fall', 'feel', 'find',
    'fly', 'forget', 'get', 'give', 'go', 'grow', 'have', 'hear', 'hold', 'keep',
    'know', 'leave', 'let', 'lose', 'make', 'meet', 'pay', 'put', 'read', 'run',
    'say', 'see', 'sell', 'send', 'set', 'sing', 'sit', 'sleep', 'speak', 'spend',
    'stand', 'swim', 'take', 'teach', 'tell', 'think', 'throw', 'understand',
    'wake', 'wear', 'win', 'write',
  ],
  [
    'awake', 'beat', 'bend', 'bet', 'bite', 'blow', 'burn', 'burst', 'cost',
    'deal', 'dig', 'dream', 'feed', 'fight', 'forgive', 'freeze', 'hang', 'hide',
    'hit', 'hurt', 'lead', 'learn', 'lend', 'lie', 'light', 'mean', 'quit', 'ride',
    'ring', 'rise', 'shake', 'shine', 'shoot', 'shut', 'sink', 'slide', 'smell',
    'spill', 'spin', 'split', 'spoil', 'spread', 'steal', 'stick', 'strike',
    'sweep', 'swing', 'tear',
  ],
  [
    'arise', 'bear', 'bind', 'bleed', 'breed', 'broadcast', 'cast', 'cling',
    'creep', 'dive', 'fit', 'flee', 'forbid', 'forecast', 'input', 'kneel', 'knit',
    'lay', 'lean', 'leap', 'mistake', 'misunderstand', 'overcome', 'oversleep',
    'overtake', 'rebuild', 'redo', 'repay', 'reread', 'reset', 'retell', 'rethink',
    'rewind', 'rewrite', 'seek', 'shrink', 'sneak', 'speed', 'spell', 'spit',
    'spring', 'sting', 'swear', 'undo', 'upset', 'weep', 'wet', 'wind', 'withdraw',
  ],
  [
    'bid', 'bust', 'dwell', 'fling', 'foresee', 'grind', 'mislead', 'misread',
    'misspell', 'outdo', 'outgrow', 'outrun', 'outshine', 'overdo', 'overeat',
    'overhear', 'override', 'oversee', 'overthrow', 'overwrite', 'plead',
    'proofread', 'redraw', 'remake', 'rerun', 'resell', 'retake', 'rid', 'shed',
    'slit', 'stink', 'stride', 'string', 'strive', 'thrive', 'tread', 'undergo',
    'undertake', 'unfreeze', 'unwind', 'uphold', 'weave', 'wed', 'withhold',
    'withstand', 'wring',
  ],
  [
    'befall', 'beget', 'behold', 'bereave', 'beseech', 'beset', 'bespeak',
    'bestride', 'chide', 'cleave', 'forbear', 'forego', 'foretell', 'forsake',
    'gainsay', 'heave', 'inlay', 'inset', 'interweave', 'miscast', 'misdeal',
    'misdo', 'mishear', 'mislay', 'misspend', 'offset', 'outbid', 'outsell',
    'overcast', 'overdraw', 'overhang', 'overlay', 'overlie', 'overrun',
    'oversell', 'overshoot', 'partake', 'rebind', 'recast', 'rehear', 'relight',
    'rend', 'shear', 'slay', 'sling', 'slink', 'smite', 'thrust', 'unbend',
    'unbind', 'underbid', 'undercut', 'underlie', 'underpay', 'undersell',
    'underwrite', 'unhang', 'unhide', 'unlearn', 'unmake', 'waylay',
  ],
];

const TIER = Object.fromEntries(
  TIER_LISTS.flatMap((list, index) => list.map((id) => [id, index + 1]))
);

export const VERBS = RAW.map(([base, ruPresent, past, ruPast, ruFuture]) => ({
  id: base,
  difficulty: TIER[base] ?? 4,
  forms: [
    { tense: 'present', en: base, ru: ruPresent },
    { tense: 'past', en: past, ru: ruPast },
    { tense: 'future', en: `will ${base}`, ru: ruFuture },
  ],
})).sort((a, b) => a.difficulty - b.difficulty || a.id.localeCompare(b.id));

export const TOTAL_WORDS = VERBS.length * 3;
